import PropTypes from 'prop-types';
import {
  JOURNEY_STEP_STATUSES,
  JOURNEY_STEP_TYPES,
  JOURNEY_TASK_STATUSES,
  TROPHY_CONFIG,
} from '../../services/utilityFunctions';

const propType = {
  _id: PropTypes.string,
  type: PropTypes.oneOf(JOURNEY_STEP_TYPES),
  pos: PropTypes.number,
  level: PropTypes.number,
  maxDays: PropTypes.number,
  journey: PropTypes.string,
  game: PropTypes.oneOfType([PropTypes.string, PropTypes.shape()]),
  survey: PropTypes.oneOfType([PropTypes.string, PropTypes.shape()]),
  course: PropTypes.oneOfType([PropTypes.string, PropTypes.shape()]),
  trophy: PropTypes.oneOf(Object.keys(TROPHY_CONFIG)),
  trophyCustom: PropTypes.oneOfType([PropTypes.string, PropTypes.shape()]),
  status: PropTypes.oneOf(JOURNEY_STEP_STATUSES),
  taskStatus: PropTypes.oneOf(JOURNEY_TASK_STATUSES),
};

export default { propType };
